import React       from 'react';
import HiddenInput from './HiddenInput';

const VendorSelected = ({ parameters, groupName }) => {
  const name = 'vendor_selected';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

VendorSelected.defaultProps = {
};

export default VendorSelected;
